var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('i',{staticClass:"el-icon-menu menu-icon",on:{"click":_vm.leftbarStatus}}),_c('profile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }